import { ChangeDetectionStrategy, Component, computed, ElementRef, inject, input, Signal } from '@angular/core';
import { WindowStore } from '../../05_layout/mdi-layout/window-tabs/window.store';
import {CdkMenu, CdkMenuItem, CdkContextMenuTrigger} from '@angular/cdk/menu';
import { I18n, TranslatePipe } from '@corporate/ng-tebis-base-components';

@Component({
  selector: 'tps-windowed-router-link',
  imports: [
    TranslatePipe,
    CdkContextMenuTrigger,
    CdkMenu,
    CdkMenuItem,
  ],
  templateUrl: './windowed-router-link.component.html',
  styleUrl: './windowed-router-link.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class WindowedRouterLinkComponent {

  elementRef = inject(ElementRef);
  windowStore = inject(WindowStore);

  url = input.required<string|string[]>();
  tabLabel = input.required<Signal<string>>();
  navUrl = computed(() => {
    let url = this.url();
    if (typeof url === 'string') {
      url = url.split('/');
    }
    return url.filter(segment => segment.length > 0).join('/');
  });

  constructor() {
    inject(I18n).addNamespace('windowtabs');
  }

  onClick(event: MouseEvent) {
    event.preventDefault();
    const windowContext = this.findWindowContext();
    if (windowContext) {
      this.windowStore.selectTabAtIndex(windowContext.windowIndex, windowContext.tabIndex);
    }
    if (event.ctrlKey) {
      this.windowStore.newTab('', 'home', this.tabLabel(), '');
    }
    this.windowStore.openAndNavigateInHomeTab(this.navUrl(), this.tabLabel());
  }

  openInNewTab(event: MouseEvent) {
    event.preventDefault();
    const windowContext = this.findWindowContext();
    if (windowContext) {
      this.windowStore.selectTabAtIndex(windowContext.windowIndex, windowContext.tabIndex);
    }
    this.windowStore.newTab(this.navUrl(), 'home', this.tabLabel(), '');
  }

  openInNewWindow(event: MouseEvent) {
    event.preventDefault();
    this.windowStore.openWindow(this.navUrl(), this.tabLabel(), '', 'home');
  }

  findWindowContext() {
    let element: HTMLElement|null = this.elementRef.nativeElement;
    while (element) {

      if (element.tagName.toLowerCase() === 'tps-window-context') {
        return { windowIndex: Number(element.getAttribute('ng-reflect-window-index')), tabIndex: Number(element.getAttribute('ng-reflect-tab-index')) };
      }

      // for (let i = 0; i < element.parentElement.childElementCount; i++) {
      //   const sibling = element.parentElement.children[i];
      //   if (sibling.tagName.toLowerCase() === 'tps-window' && sibling.hasAttribute('name')) {
      //     return sibling.getAttribute('name') || '';
      //   }
      // }

      element = element.parentElement;
    }
    return null;
  }
}
